import { render, staticRenderFns } from "./used-book-selection-dialog.vue?vue&type=template&id=b5ccc8fc&scoped=true&"
import script from "./used-book-selection-dialog.vue?vue&type=script&lang=js&"
export * from "./used-book-selection-dialog.vue?vue&type=script&lang=js&"
import style0 from "./used-book-selection-dialog.vue?vue&type=style&index=0&id=b5ccc8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ccc8fc",
  null
  
)

export default component.exports